import { CoreOperationResult } from "../../core/index.js";
import { DataPsmCreate } from "./data-psm-create.js";
import * as PSM from "../data-psm-vocabulary.js";
export class DataPsmCreateAssociationEnd extends DataPsmCreate {
    static TYPE = PSM.CREATE_ASSOCIATION_END;
    dataPsmOwner = null;
    dataPsmPart = null;
    dataPsmIsReverse = null;
    dataPsmIsDematerialize = null;
    constructor() {
        super();
        this.types.push(DataPsmCreateAssociationEnd.TYPE);
    }
    static is(resource) {
        return resource?.types.includes(DataPsmCreateAssociationEnd.TYPE);
    }
}
export class DataPsmCreateAssociationEndResult extends CoreOperationResult {
    static TYPE = PSM.CREATE_ASSOCIATION_END_RESULT;
    createdDataPsmAssociationEnd;
    constructor(dataPsmAssociationEnd) {
        super();
        this.types.push(DataPsmCreateAssociationEndResult.TYPE);
        this.createdDataPsmAssociationEnd = dataPsmAssociationEnd;
    }
    static is(resource) {
        return resource?.types.includes(DataPsmCreateAssociationEndResult.TYPE);
    }
}
//# sourceMappingURL=data-psm-create-association-end.js.map